import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const setShowUneditedContentReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean>) => {
    state.showUneditedContent = action.payload;
  });
};

export default setShowUneditedContentReducer;
